export const LOCALE_KEY = 'poeLocale'

export function readLocale() {
  try {
    const value = localStorage.getItem(LOCALE_KEY)
    return value === 'en' ? 'en' : 'th'
  } catch (error) {
    return 'th'
  }
}

export function applyLocale(i18n, locale) {
  const next = locale === 'en' ? 'en' : 'th'
  if (i18n) {
    i18n.locale = next
  }
  try {
    localStorage.setItem(LOCALE_KEY, next)
  } catch (error) {
    // ignore
  }
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', next)
  }
  return next
}
